/* ═══════════════════════════════════════════════════════════════════
   STUDIO FISHY — Theme JavaScript
   Handles: Menu drawer, cart animations, size selection
   ═══════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  // ── Menu Drawer ──────────────────────────────────────────────────
  function initMenuDrawer() {
    const overlay = document.querySelector('.sf-menu-overlay');
    const drawer = document.querySelector('.sf-menu-drawer');
    const openBtn = document.querySelector('.sf-header__menu-btn');
    const closeBtn = document.querySelector('.sf-menu-drawer__close');

    if (!overlay || !drawer) return;

    function openMenu() {
      overlay.classList.add('open');
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      overlay.classList.remove('open');
      drawer.classList.remove('open');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);

    // Close on nav link click
    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  // ── Cart Count Update ────────────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('.sf-header__cart-count');
        if (countEl) {
          countEl.textContent = '(' + cart.item_count + ')';
        }
      })
      .catch(function () {});
  }

  // ── Size Selector (Product Page) ─────────────────────────────────
  function initSizeSelector() {
    var sizeButtons = document.querySelectorAll('.sf-size-btn');
    var hiddenInput = document.querySelector('[name="id"]');

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeButtons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        // Set variant ID
        var variantId = btn.dataset.variantId;
        if (hiddenInput && variantId) {
          hiddenInput.value = variantId;
        }
      });
    });
  }

  // ── Add to Cart Animation ────────────────────────────────────────
  function initAddToCart() {
    var form = document.querySelector('.sf-product-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.textContent = '✓ נוסף לסל';
        submitBtn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          updateCartCount();
          // Animate cart icon
          var cartEl = document.querySelector('.sf-header__cart');
          if (cartEl) {
            cartEl.classList.add('cart-bump');
            setTimeout(function () { cartEl.classList.remove('cart-bump'); }, 700);
          }
          setTimeout(function () {
            if (submitBtn) {
              submitBtn.textContent = 'הוספה לסל';
              submitBtn.disabled = false;
            }
          }, 2000);
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.textContent = 'שגיאה, נסה שוב';
            submitBtn.disabled = false;
          }
        });
    });
  }

  // ── Product Image Gallery ─────────────────────────────────────────
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.sf-product-thumb');
    var mainImg = document.querySelector('.sf-product-main-img');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg) {
          mainImg.src = thumb.dataset.full || thumb.src;
        }
      });
    });
  }

  // ── Newsletter Form ───────────────────────────────────────────────
  function initNewsletter() {
    var form = document.querySelector('.sf-footer__email-form');
    if (!form) return;
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button');

    if (btn) {
      btn.addEventListener('click', function () {
        if (!input || !input.value) return;
        // Shopify uses the native newsletter form — handled server-side
        // For now we just show a thank you message
        input.value = '';
        input.placeholder = '✓ נרשמת בהצלחה!';
        btn.textContent = '✓';
        setTimeout(function () {
          input.placeholder = 'המייל שלך';
          btn.textContent = 'שלח';
        }, 3000);
      });
    }
  }

  // ── Product Card Video Hover Playback (Lazy Loaded - Desktop Only) ────────────────
  function initCardVideoHover() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const cards = document.querySelectorAll('.sf-product-card');
    cards.forEach(function (card) {
      const video = card.querySelector('video.sf-product-card__video-hover');
      if (video) {
        card.addEventListener('mouseenter', function () {
          if (!video.src && video.dataset.src) {
            video.src = video.dataset.src;
            video.load();
          }
          video.currentTime = 0;
          video.play().catch(function (e) {
            console.log('Video play blocked:', e);
          });
        });
        card.addEventListener('mouseleave', function () {
          video.pause();
        });
      }
    });
  }

  // ── Lazy Load Gallery Videos (Intersection Observer) ────────────────
  function initLazyVideos() {
    const lazyVideos = document.querySelectorAll('video.sf-lazy-video');
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const video = entry.target;
            if (!video.src && video.dataset.src) {
              video.src = video.dataset.src;
              video.load();
              if (video.hasAttribute('autoplay')) {
                video.play().catch(function (e) {
                  console.log('Autoplay blocked:', e);
                });
              }
            }
            videoObserver.unobserve(video);
          }
        });
      }, { rootMargin: '0px 0px 300px 0px' });

      lazyVideos.forEach(function (video) {
        videoObserver.observe(video);
      });
    } else {
      lazyVideos.forEach(function (video) {
        if (video.dataset.src) {
          video.src = video.dataset.src;
          video.load();
        }
      });
    }
  }

  // ── Init ─────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    initMenuDrawer();
    // initSizeSelector(); // Handled locally in product.liquid
    // initAddToCart();    // Handled locally in product.liquid
    initProductGallery();
    initNewsletter();
    initCardVideoHover();
    initLazyVideos();
    updateCartCount();
  });

})();
